import { IntegrationsSyncableStateStatusEnum } from 'generated/resources/graphql'

export type GroupedStatus =
  | 'syncing'
  | 'pending'
  | 'outdated'
  | 'partiallySynced'
  | 'failed'
  | 'synced'

export const groupedStatuses = (
  statusesGroups: Set<IntegrationsSyncableStateStatusEnum>[]
): GroupedStatus[] => {
  return statusesGroups.map((statuses) => {
    const statusesArray = Array.from(statuses)
    if (isSyncing(statusesArray)) return 'syncing'
    if (isOutdated(statusesArray)) return 'outdated'
    if (isPartiallySynced(statusesArray)) return 'partiallySynced'
    if (hasFailed(statusesArray)) return 'failed'
    return 'synced'
  })
}

export const isSyncing = (syncableStates: Array<IntegrationsSyncableStateStatusEnum | undefined>) =>
  syncableStates.length > 0 && syncableStates.some((syncableState) => syncableState === 'syncing')

export const isPending = (syncableStates: Array<IntegrationsSyncableStateStatusEnum | undefined>) =>
  syncableStates.length === 0 ||
  syncableStates.every((syncableState) => syncableState === undefined)

export const isOutdated = (
  syncableStates: Array<IntegrationsSyncableStateStatusEnum | undefined>
) => {
  return (
    syncableStates.some((syncableState) => syncableState === 'outdated') ||
    (syncableStates.some((syncableState) => syncableState === undefined) &&
      syncableStates.some((syncableState) => syncableState !== undefined))
  )
}

export const hasFailed = (syncableStates: Array<IntegrationsSyncableStateStatusEnum | undefined>) =>
  syncableStates.some((syncableState) => syncableState === 'failed') ||
  syncableStates.some((syncableState) => syncableState === 'invalid')

export const isPartiallySynced = (
  syncableStates: Array<IntegrationsSyncableStateStatusEnum | undefined>
) => syncableStates.some((syncableState) => syncableState === 'synced') && hasFailed(syncableStates)
